import React, {useState} from 'react';
import UniversityDropdown from 'src/views/admin/UniversityDropdown';
import {EducationPhase} from 'src/types/enums';
import EditableTable from 'src/views/admin/EditableTable';

const columns = [
  {
    name: 'raisemeColumnName',
    title: 'Raise Me Column',
    width: '50%',
    sortable: true,
  },
  {
    name: 'sponsorColumnName',
    title: 'Sponsor Column',
    sortable: true,
  },
];

const UGSSColumnMappings = (): React.ReactElement => {
  const [universityId, setUniversityId] = useState(null);

  return (
    <div data-testid="ugss-column-mappings">
      <UniversityDropdown
        autoSelectFirstUniversity
        value={universityId}
        onChange={setUniversityId}
        educationPhases={[EducationPhase.UNDERGRADUATE]}
      />
      {universityId && (
        <EditableTable
          basePath={`/v1/sponsors/${universityId}/column-mappings`}
          defaultSortKey="raisemeColumnName"
          columns={columns}
          identifier={universityId}
        />
      )}
    </div>
  );
};

export default UGSSColumnMappings;
